const Checkbox = ({ checked = false, onChange }) => {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      onClick={onChange}
      className={`
        flex h-5 w-5 items-center justify-center rounded
        border transition-colors
        ${
          checked
            ? "border-toicos-navy bg-toicos-navy"
            : "border-gray-300 bg-white hover:border-gray-400"
        }
      `}
    >
      {checked && (
        <svg
          viewBox="0 0 16 16"
          className="h-3.5 w-3.5 text-white"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M3 8l3 3 7-7" />
        </svg>
      )}
    </button>
  )
}

export default Checkbox
